import { createAsyncThunk } from '@reduxjs/toolkit';
import fetchBusinessInfo from 'utils/fetchBusinessInfo';
import { selectOrganizationBusinessIdToAdd } from '../selectors/organizationChart.selectors';

export const loadOrganizationChartBusinessInformationByBusinessId =
  createAsyncThunk(
    'organizationCharts/loadOrganizationChartBusinessInformationByBusinessId',
    async (_, { getState }) => {
      const businessIdToSearch = selectOrganizationBusinessIdToAdd(getState());

      const response = await fetchBusinessInfo(businessIdToSearch);

      return response;
    }
  );
